import { ShowcaseImage } from "@/app/interfaces/showcaseImage";
import { buildCloudinaryUrl } from "@/app/utils/lib/cloudinaryLoader";

// 250px CSS size at 2x DPR. Must stay in sync with .trailImage in ImageTrailHero.module.css.
export const TRAIL_IMAGE_WIDTH = 500;
export const TRAIL_IMAGE_HEIGHT = 600;

// Shared by the page-level preload and the hero so both hit the same Cloudinary URL (warm cache).
export function getTrailImageUrl(img: ShowcaseImage): string {
  return img.cloudinaryPublicId
    ? buildCloudinaryUrl(img.cloudinaryPublicId, {
        width: TRAIL_IMAGE_WIDTH,
        quality: "auto:eco",
      })
    : img.imageUrl;
}
